export const NAME = 'consts';
